import { CircularProgress, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { UserAccessStatePanel } from './UserAccessStatePanel';

export function UserAccessLoadingState({ header }: { header?: ReactNode }) {
  const { t } = useTranslation();

  return (
    <UserAccessStatePanel header={header} minHeight={240}>
      <Stack alignItems="center" justifyContent="center" flex={1}>
        <CircularProgress aria-label={t('userAccessControl.loading')} />
      </Stack>
    </UserAccessStatePanel>
  );
}
